import { createWorld } from 'bitecs';
export const createGameWorld = () => {
    const world = createWorld();
    world.time = {
        tick: 0,
        delta: 0,
        elapsed: 0,
    };
    return world;
};
//# sourceMappingURL=world.js.map